module.exports = __webpack_public_path__ + "img/landingpage.7895219e.svg";